/* luv-ritual-price.js v5-thresholds 1778794076 */
/* TS 1778790474 */
/*
  luv-ritual-price.js — safe rewrite v2
  No MutationObserver. Event delegation + rAF batching. Adds containers to
  pendingSet on click so flush actually runs. Includes data-luv-active-mode
  filter and is-included/is-excluded class handling.
*/
(function () {
  'use strict';
  if (window.__LUV_RP_INIT__) return;
  window.__LUV_RP_INIT__ = true;

  // Thresholds locked 2026-05-29 (C9 fix): £75/120 · 90 €/145 € · $75/150
  var THRESHOLDS = {
    GBP: { ship: 7500,  candle: 12000, symbol: '\u00A3' },
    EUR: { ship: 9000,  candle: 14500, symbol: '\u20AC' },
    USD: { ship: 7500,  candle: 15000, symbol: '$' }
  };

  function detectCurrency() {
    var c = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
            document.documentElement.getAttribute('data-currency') || 'GBP';
    return THRESHOLDS[c] ? c : 'GBP';
  }

  function fmtMoney(cents, currency) {
    var t = THRESHOLDS[currency] || THRESHOLDS.GBP;
    var v = cents / 100;
    var s = (Math.round(v * 100) / 100).toFixed(2).replace(/\.00$/, '');
    return t.symbol + s;
  }

  function compute(items, currency) {
    var selected = [];
    for (var i = 0; i < items.length; i++) if (items[i].selected) selected.push(items[i]);
    var subtotal = 0;
    var heroes = [];
    for (var j = 0; j < selected.length; j++) {
      subtotal += selected[j].cents;
      if (selected[j].hero) heroes.push(selected[j].cents);
    }
    heroes.sort(function (a, b) { return a - b; });
    var pairs = Math.floor(heroes.length / 2);
    var discount = 0;
    for (var k = 0; k < pairs; k++) discount += Math.round(heroes[k] * 0.30);
    var total = subtotal - discount;
    var t = THRESHOLDS[currency] || THRESHOLDS.GBP;
    return {
      currency: currency, subtotal: subtotal, discount: discount, total: total,
      count: selected.length,
      free_shipping: total >= t.ship,
      free_candle: total >= t.candle
    };
  }

  function renderHTML(state) {
    if (state.count === 0) return '<span class="luv-rp__empty">Select at least one step</span>';
    var parts = [];
    if (state.discount > 0) {
      parts.push('<span class="luv-rp__was"><s>' + fmtMoney(state.subtotal, state.currency) + '</s></span>');
      parts.push('<span class="luv-rp__now"><strong>' + fmtMoney(state.total, state.currency) + '</strong></span>');
      parts.push('<span class="luv-rp__save">Save ' + fmtMoney(state.discount, state.currency) + '</span>');
    } else {
      parts.push('<span class="luv-rp__now"><strong>' + fmtMoney(state.total, state.currency) + '</strong></span>');
    }
    var html = '<span class="luv-rp__row">' + parts.join(' ') + '</span>';
    var t = THRESHOLDS[state.currency] || THRESHOLDS.GBP;
    var toShip = Math.max(0, t.ship - state.total);
    var toCandle = Math.max(0, t.candle - state.total);
    if (state.free_candle) {
      html += '<span class="luv-rp__perks">Free shipping and free candle unlocked</span>';
    } else if (state.free_shipping) {
      html += '<span class="luv-rp__perks">Free shipping unlocked. ' + fmtMoney(toCandle, state.currency) + ' away from a free candle</span>';
    } else {
      html += '<span class="luv-rp__perks">' + fmtMoney(toShip, state.currency) + ' away from free shipping. ' + fmtMoney(toCandle, state.currency) + ' away from a free candle</span>';
    }
    return html;
  }

  function render(displayEl, state) {
    if (!displayEl) return;
    var html = renderHTML(state);
    if (displayEl.getAttribute('data-luv-rp-html') === html) return;
    displayEl.setAttribute('data-luv-rp-html', html);
    displayEl.innerHTML = html;
  }

  function findDisplay(container) {
    var inside = container.querySelector('[data-luv-ritual-price="display"]');
    if (inside) return inside;
    if (container.id) {
      var ext = document.querySelector('[data-luv-ritual-price-display-for="' + container.id + '"]');
      if (!ext) return null;
      return ext.querySelector('[data-luv-ritual-price="display"]') || ext;
    }
    return null;
  }

  function collect(container) {
    var sel = container.getAttribute('data-step-selector') || '[data-cents]';
    var mode = container.getAttribute('data-luv-active-mode');
    var nodes;
    try { nodes = container.querySelectorAll(sel); } catch (e) { return []; }
    var items = [];
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var cents = parseInt(n.getAttribute('data-cents') || '0', 10);
      if (!cents || cents <= 0) continue;
      if (mode) {
        var nm = n.getAttribute('data-mode');
        if (nm && nm !== mode) continue;
      }
      var hero = n.getAttribute('data-hero') === '1' || n.getAttribute('data-hero') === 'true';
      var cls = n.classList;
      var s;
      if (cls.contains('is-out') || cls.contains('is-excluded')) s = false;
      else s = true;
      items.push({ cents: cents, hero: hero, selected: s });
    }
    return items;
  }

  function updateContainer(container) {
    var d = findDisplay(container);
    if (!d) return;
    var state = compute(collect(container), detectCurrency());
    render(d, state);
    try { container.dispatchEvent(new CustomEvent('luvRitualPrice:change', { detail: state, bubbles: true })); } catch (e) {}
  }

  // Scheduler
  var pendingAll = false;
  var pendingSet = null;
  var scheduled = false;

  function flush() {
    scheduled = false;
    var targets;
    if (pendingAll) {
      targets = document.querySelectorAll('[data-luv-ritual-price="container"]');
    } else if (pendingSet) {
      targets = [];
      pendingSet.forEach(function (item) { targets.push(item); });
    } else {
      return;
    }
    pendingAll = false;
    pendingSet = null;
    for (var i = 0; i < targets.length; i++) {
      try { updateContainer(targets[i]); } catch (e) { /* swallow */ }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(flush);
    else setTimeout(flush, 16);
  }

  function refresh(scope) {
    if (!scope) {
      pendingAll = true;
    } else {
      var container = (scope.closest && scope.closest('[data-luv-ritual-price="container"]')) || null;
      if (container) {
        if (!pendingSet) pendingSet = new Set();
        pendingSet.add(container);
      } else {
        pendingAll = true;
      }
    }
    schedule();
  }

  // Click delegation : after the section's click handler runs, recompute on
  // the next frame. We enqueue the container explicitly so flush has work.
  function onDocClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var container = t.closest('[data-luv-ritual-price="container"]');
    if (!container) return;
    // Defer one frame so other handlers can mutate classes first.
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () { refresh(container); });
    } else {
      setTimeout(function () { refresh(container); }, 16);
    }
  }

  function init() {
    refresh();
    document.addEventListener('click', onDocClick, false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.LuvRitualPrice = {
    refresh: refresh,
    compute: compute,
    render: render,
    fmtMoney: fmtMoney,
    detectCurrency: detectCurrency
  };
})();
